var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBag = function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.4 4v.8h3.2V4c0-.883-.717-1.6-1.6-1.6-.882 0-1.6.717-1.6 1.6m-.8 1.6H3.2v8h9.6v-8h-2.4V8h-.8V5.6H6.4V8h-.8V5.6m0-.8V4a2.4 2.4 0 0 1 4.8 0v.8h3.2v9.6H2.4V4.8h3.2"
  })));
};
export default SvgBag;